import React from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label
} from 'reactstrap';

interface DeleteConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onDelete: () => void;
}
const DeleteConfirmationModal = ({
    isOpen,
    onClose,
    onDelete
}: DeleteConfirmationModalProps) => {
    return (
        <Modal isOpen={isOpen} toggle={onClose}>
            <ModalHeader
                className="modal-title-custom text-white font-size-16"
                toggle={onClose}
            >
                Delete Contact
            </ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label htmlFor="update-bookmark" className="mb-2">
                            Are you sure you want to delete this contact?
                        </Label>
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button type="button" color="none" onClick={onClose}>
                    Close
                </Button>
                <Button color="primary" onClick={onDelete}>
                    Confirm
                </Button>{' '}
            </ModalFooter>
        </Modal>
    );
};

export default DeleteConfirmationModal;
